//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required, minLength } from 'vuelidate/lib/validators';
import * as api from '@/services/api';
import turnstileMixin, {
  TURNSTILE_PENDING_MESSAGE
} from '@/mixins/turnstileMixin';

export default {
  mixins: [turnstileMixin],
  data() {
    return {
      email: '',
      subject: '',
      message: ''
    };
  },
  validations: {
    email: { email, required },
    subject: { required },
    message: { required, minLength: minLength(20) }
  },
  methods: {
    async contact() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      if (!this.turnstileReady) {
        this.$toast.error(TURNSTILE_PENDING_MESSAGE);
        return;
      }
      try {
        await api.send(
          this.email,
          'BOMIST [sales] ' + this.subject,
          this.message,
          this.turnstileToken
        );
        this.clear();
        this.$refs.modalSent.open();
      } catch (err) {
        this.$toast.error(err.response ? err.response.data.message : err);
        if (this.$sentry) {
          this.$sentry.captureException(err);
        }
      } finally {
        this.resetTurnstile();
      }
    },
    handleSent() {
      this.$router.push('/');
    },
    clear() {
      this.email = '';
      this.subject = '';
      this.message = '';
      this.$v.$reset();
    }
  }
};
